import PublicLayout from '../../../components/public/PublicLayout';
import Hero from '../../../components/public/Hero';
import { NoRealData } from '@/components/shared';

export default function MapPage(){return <PublicLayout>
 <Hero title="Mapa das Árvores de Goiânia" subtitle="Explore a arborização urbana da nossa cidade" description="O mapa mostrará a localização, as espécies e a condição dos exemplares arbóreos de Goiânia." />
 <div className="page-pad">
  <NoRealData variant="page" title="Mapa público dos exemplares arbóreos" description="Ainda não há consulta pública do inventário. Quando for publicada, o mapa trará os exemplares cadastrados com filtros por espécie, condição, risco e bairro." icon="ri-map-2-line"/>
 </div>
 </PublicLayout>}
